module.exports = __webpack_public_path__ + "static/img/4480_phase_function_Paper_PointsHejduk_Prediction.c2f6268.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4480_phase_function_Paper_PointsHejduk_Prediction.png
// module id = bsH/
// module chunks = 0